import { UserHistoryTab } from '@app/components';
import { UserIntegrationsTab } from '@app/components/UserIntegrationsTab/UserIntegrationsTab';
import { CLIENT_SERVICES_LABEL } from '@app/constants';
import { Portfolio } from '@app/pages/Portfolio';
import { generateSpanWithDataTestId } from '@app/shared/utils';
import type { NEmployees } from '@app/types';

import {
  ClientServicesTab,
  EmployeeAdditionalInfoTab,
  EmployeeInfoTab,
  EmployeeSettingsTab,
} from '@pages/Employees/EditEmployee/components';
import { AccessRightsTab, UserPreview } from '@pages/Users';

export const TabsData = (data: NEmployees.EditEmployeeInfoTabProps) => {
  const {
    employee,
    setNewData,
    newData,
    allServices,
    setAllServices,
    hasUserRightToEdit,
    allSettings,
    setEmployee,
    hasUserRightToViewAccessRightTab,
    setIsNeedToUpdateUserPreview,
    hasUserRightToAttachServices,
    editableUserAccessRights,
    editableUserUnsavedAccessRights,
    setEditableUserUnsavedAccessRights,
    isGetUserAccessRightsLoading,
    setEditableUserAccessRights,
    hasCurrentUserRightToViewAllRecords,
    getEmployeeData,
    servicesLoadState,
    setHandleUnsavedChanges,
  } = data;

  const TabsData = [
    {
      label: generateSpanWithDataTestId('Общая информация', 'general-info-tab'),
      key: '1',
      children: <UserPreview />,
    },
    ...(hasUserRightToEdit && !employee?.isDeleted
      ? [
          {
            label: generateSpanWithDataTestId('Редактировать', 'edit-tab'),
            key: '2',
            children: (
              <EmployeeInfoTab
                employee={employee}
                newData={newData}
                setEmployee={setEmployee}
                setNewData={setNewData}
                setIsNeedToUpdateUserPreview={setIsNeedToUpdateUserPreview}
                setHandleUnsavedChanges={setHandleUnsavedChanges}
              />
            ),
          },
          ...(hasUserRightToViewAccessRightTab
            ? [
                {
                  label: generateSpanWithDataTestId(
                    'Права доступа',
                    'access-tab'
                  ),
                  key: '8',
                  children: (
                    <AccessRightsTab
                      editableUserAccessRights={editableUserAccessRights}
                      editableUserUnsavedAccessRights={
                        editableUserUnsavedAccessRights
                      }
                      setEditableUserUnsavedAccessRights={
                        setEditableUserUnsavedAccessRights
                      }
                      isGetUserAccessRightsLoading={
                        isGetUserAccessRightsLoading
                      }
                      setEditableUserAccessRights={setEditableUserAccessRights}
                    />
                  ),
                },
              ]
            : []),
          {
            label: generateSpanWithDataTestId(
              'Дополнительно',
              'additional-tab'
            ),
            key: '3',
            children: (
              <EmployeeAdditionalInfoTab
                employee={employee}
                setNewData={setNewData}
                newData={newData}
                setEmployee={setEmployee}
                setIsNeedToUpdateUserPreview={setIsNeedToUpdateUserPreview}
                setHandleUnsavedChanges={setHandleUnsavedChanges}
              />
            ),
          },
        ]
      : []),
    ...(hasUserRightToEdit && !employee?.isDeleted
      ? [
          {
            label: generateSpanWithDataTestId(
              'Настройки уведомлений',
              'settings-tab'
            ),
            key: '4',
            children: (
              <EmployeeSettingsTab
                employee={employee}
                allSettings={allSettings}
                hasCurrentUserRightToViewAllRecords={
                  hasCurrentUserRightToViewAllRecords
                }
              />
            ),
          },
        ]
      : []),
    ...(!employee?.isDeleted && hasUserRightToAttachServices
      ? [
          {
            label: generateSpanWithDataTestId(
              CLIENT_SERVICES_LABEL,
              'services-tab'
            ),
            key: '5',
            children: (
              <ClientServicesTab
                employee={employee}
                allServices={allServices}
                setAllServices={setAllServices}
                setNewData={setNewData}
                getEmployeeData={getEmployeeData}
                servicesLoadState={servicesLoadState}
              />
            ),
          },
        ]
      : []),
    {
      label: generateSpanWithDataTestId('Портфолио', 'portfolio-tab'),
      key: '6',
      children: <Portfolio />,
    },
    {
      label: generateSpanWithDataTestId('История', 'history-tab'),
      key: '7',
      children: <UserHistoryTab user={employee} />,
    },
    {
      label: generateSpanWithDataTestId(
        'Социальные интеграции',
        'social-integration-tab'
      ),
      key: '9',
      children: <UserIntegrationsTab />,
    },
  ];

  return TabsData;
};
